const AreaItem = ({ area }) => {
  return (
    <div className='border rounded px-2 py-1 bg-plum hover:bg-opacity-70 text-white cursor-pointer'>
      {area}
    </div>
  );
};

export default AreaItem;
